import React from "react";
import Heading from "../utilities/Heading";
import { CiChat2 } from "react-icons/ci";

function Testimonials() {
  return (
    <div className="container">
      <div className="w-full">
        <Heading title={"Testimonials"} description={"Hear from Our Satisfied Clients: Read Our Testimonials to Learn More about Our Digital Marketing Services"} style={"lg:w-[200px]"} />

        <div className="bg-secondary rounded-2xl p-16">
          <div className="snap-x overflow-x-auto flex space-x-32 lg:space-x-8">
            <div className="snap-center flex-shrink-0 w-full lg:w-2/4">
              <div className="w-[280px] lg:w-full relative ">
                <div className="lg:hidden">
                  <img src="/images/Union.svg" alt="Buble" className="m-auto pt-3" />
                </div>

                <div className="hidden lg:block">
                  <img src="/images/Bubble.svg" alt="..." />
                </div>

                <p className="text-third w-3/4 absolute top-7 lg:top-3 lg:left-14 right-9 text-sm text-left lg:text-lg ">
                  "We have been working with Positivus for the past year and have seen a significant increase in website traffic and leads as a result of their efforts. The team is professional, responsive, and truly cares about the success
                  of our business. We highly recommend Positivus to any company looking to grow their online presence."
                </p>
              </div>

              <div className="w-full">
                <div className="text-left ml-14 my-2">
                  <h1 className="text-primary font-semibold">Jhon Smith</h1>
                  <p className="text-third">Marketing Director at XYZ Corp</p>
                </div>
              </div>
            </div>
            <div className="snap-always snap-center flex-shrink-0 w-full lg:w-2/4">
              <div className="w-[280px] lg:w-full relative ">
                <div className="lg:hidden">
                  <img src="/images/Union.svg" alt="Buble" className="m-auto pt-3" />
                </div>

                <div className="hidden lg:block">
                  <img src="/images/Bubble.svg" alt="..." />
                </div>

                <p className="text-third w-3/4 absolute top-7 lg:top-3 lg:left-14 right-9 text-sm text-left lg:text-lg ">
                  "We have been working with Positivus for the past year and have seen a significant increase in website traffic and leads as a result of their efforts. The team is professional, responsive, and truly cares about the success
                  of our business. We highly recommend Positivus to any company looking to grow their online presence."
                </p>
              </div>

              <div className="w-full">
                <div className="text-left ml-14 my-2">
                  <h1 className="text-primary font-semibold">Jhon Smith</h1>
                  <p className="text-third">Marketing Director at XYZ Corp</p>
                </div>
              </div>
            </div>
            <div className="snap-always snap-center flex-shrink-0 w-full lg:w-2/4">
              <div className="w-[280px] lg:w-full relative ">
                <div className="lg:hidden">
                  <img src="/images/Union.svg" alt="Buble" className="m-auto pt-3" />
                </div>

                <div className="hidden lg:block">
                  <img src="/images/Bubble.svg" alt="..." />
                </div>

                <p className="text-third w-3/4 absolute top-7 lg:top-3 lg:left-14 right-9 text-sm text-left lg:text-lg ">
                  "We have been working with Positivus for the past year and have seen a significant increase in website traffic and leads as a result of their efforts. The team is professional, responsive, and truly cares about the success
                  of our business. We highly recommend Positivus to any company looking to grow their online presence."
                </p>
              </div>

              <div className="w-full">
                <div className="text-left ml-14 my-2">
                  <h1 className="text-primary font-semibold">Jhon Smith</h1>
                  <p className="text-third">Marketing Director at XYZ Corp</p>
                </div>
              </div>
            </div>
            <div className="snap-always snap-center flex-shrink-0 w-full lg:w-2/4">
              <div className="w-[280px] lg:w-full relative ">
                <div className="lg:hidden">
                  <img src="/images/Union.svg" alt="Buble" className="m-auto pt-3" />
                </div>

                <div className="hidden lg:block">
                  <img src="/images/Bubble.svg" alt="..." />
                </div>

                <p className="text-third w-3/4 absolute top-7 lg:top-3 lg:left-14 right-9 text-sm text-left lg:text-lg ">
                  "We have been working with Positivus for the past year and have seen a significant increase in website traffic and leads as a result of their efforts. The team is professional, responsive, and truly cares about the success
                  of our business. We highly recommend Positivus to any company looking to grow their online presence."
                </p>
              </div>

              <div className="w-full">
                <div className="text-left ml-14 my-2">
                  <h1 className="text-primary font-semibold">Jhon Smith</h1>
                  <p className="text-third">Marketing Director at XYZ Corp</p>
                </div>
              </div>
            </div>
            <div className="snap-always snap-center flex-shrink-0 w-full lg:w-2/4">
              <div className="w-[280px] lg:w-full relative ">
                <div className="lg:hidden">
                  <img src="/images/Union.svg" alt="Buble" className="m-auto pt-3" />
                </div>

                <div className="hidden lg:block">
                  <img src="/images/Bubble.svg" alt="..." />
                </div>

                <p className="text-third w-3/4 absolute top-7 lg:top-3 lg:left-14 right-9 text-sm text-left lg:text-lg ">
                  "We have been working with Positivus for the past year and have seen a significant increase in website traffic and leads as a result of their efforts. The team is professional, responsive, and truly cares about the success
                  of our business. We highly recommend Positivus to any company looking to grow their online presence."
                </p>
              </div>

              <div className="w-full">
                <div className="text-left ml-14 my-2">
                  <h1 className="text-primary font-semibold">Jhon Smith</h1>
                  <p className="text-third">Marketing Director at XYZ Corp</p>
                </div>
              </div>
            </div>
            <div className="snap-always snap-center flex-shrink-0 w-full lg:w-2/4">
              <div className="w-[280px] lg:w-full relative ">
                <div className="lg:hidden">
                  <img src="/images/Union.svg" alt="Buble" className="m-auto pt-3" />
                </div>

                <div className="hidden lg:block">
                  <img src="/images/Bubble.svg" alt="..." />
                </div>

                <p className="text-third w-3/4 absolute top-7 lg:top-3 lg:left-14 right-9 text-sm text-left lg:text-lg ">
                  "We have been working with Positivus for the past year and have seen a significant increase in website traffic and leads as a result of their efforts. The team is professional, responsive, and truly cares about the success
                  of our business. We highly recommend Positivus to any company looking to grow their online presence."
                </p>
              </div>

              <div className="w-full">
                <div className="text-left ml-14 my-2">
                  <h1 className="text-primary font-semibold">Jhon Smith</h1>
                  <p className="text-third">Marketing Director at XYZ Corp</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Testimonials;
